module.exports = __webpack_public_path__ + "fonts/Roboto-700-greek52.e58ff47.woff2";